module.exports = __webpack_public_path__ + "static/img/title.6a6f08f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/thuer/title.jpg
// module id = 461
// module chunks = 1